module.exports = __webpack_public_path__ + "a8389f4e8bd16c8460c4ef13b76d2762.jpg";